// extracted by mini-css-extract-plugin
module.exports = {"employees":"Employees_employees__1ak1Q"};